
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  getCardRecord,
  getCardRecharge,
  getCardRefund
} from "@/api/api-non-name";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiHairpinManage extends Vue {
  private tabsList: object[] = [
    { value: "record", title: i18n.t("nonFundHistory.chargedTab") },
    { value: "recharge", title: i18n.t("nonFundHistory.rechargedTab") }
  ];
  public tabChange(data: string): void {
    this.tabsActive = data;
  }
  private tabsActive = "record";

  private timeRecord: objAny = {};
  private searchKeysRecord: objAny = {
    startTime: "",
    endTime: "",
    queryType: "all",
    globalSearch: ""
  };
  private formInlineRecord: objAny = {
    cardPkId: "",
    dateStr: "",
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private cardPkId = "";
  private totalRecord = 0;
  private tableListRecord: object[] = [];
  private tableColumnsRecord: object[] = [
    {
      title: i18n.t("nonCard.accountPkId"),
      key: "accountPkId",
      align: "center",
      minWidth: 80
    },
    {
      title: i18n.t("nonFundHistory.staName"),
      key: "staName",
      align: "center",
      minWidth: 160
    },
    {
      title: i18n.t("nonFundHistory.chargeBeginTime"),
      key: "chargeBeginTime",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.chargeEndTime"),
      key: "chargeEndTime",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.chargeMinutes"),
      key: "chargeMinutes",
      align: "center",
      minWidth: 70
    },
    {
      title: i18n.t("nonFundHistory.chargeElect"),
      key: "chargeElect",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.delayAmount"),
      key: "delayAmount",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.delayDuration"),
      key: "delayDuration",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.chargeAmount"),
      key: "chargeAmount",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.beforeBalance"),
      key: "beforeBalance",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.afterBalance"),
      key: "afterBalance",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.orderNo"),
      key: "orderNo",
      align: "center",
      minWidth: 100
    }
  ];

  private timeRecharge: objAny = {};

  private searchKeysRecharge: objAny = {
    startTime: "",
    endTime: "",
    queryType: "all",
    globalSearch: ""
  };
  private formInlineRecharge: objAny = {
    cardPkId: "",
    dateStr: "",
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private totalRecharge = 0;
  private tableListRecharge: object[] = [];
  private tableColumnsRecharge: object[] = [
    {
      title: i18n.t("nonCard.accountPkId"),
      key: "accountPkId",
      align: "center",
      minWidth: 120
    },
    {
      title: i18n.t("nonFundHistory.transactionTime"),
      key: "transactionTime",
      align: "center",
      minWidth: 150
    },
    {
      title: i18n.t("nonFundHistory.rechargeAmount"),
      key: "rechargeAmount",
      align: "center",
      minWidth: 80
    },
    {
      title: i18n.t("nonFundHistory.beforeBalance"),
      key: "beforeBalance",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.afterBalance"),
      key: "afterBalance",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.createName"),
      key: "createName",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.orderNo"),
      key: "orderNo",
      align: "center",
      minWidth: 200
    }
  ];

  private timeRefund: objAny = {};

  private searchKeysRefund: objAny = {
    startTime: "",
    endTime: "",
    queryType: "all",
    globalSearch: ""
  };
  private formInlineRefund: objAny = {
    cardPkId: "",
    dateStr: "",
    globalPageIndex: 1,
    globalPageSize: 10
  };
  private totalRefund = 0;
  private tableListRefund: object[] = [];
  private tableColumnsRefund: object[] = [
    {
      title: i18n.t("nonCard.accountPkId"),
      key: "cardPkId",
      align: "center",
      minWidth: 140
    },
    {
      title: i18n.t("nonCard.cardSerialNumber"),
      key: "cardSerialNumber",
      align: "center",
      minWidth: 200
    },
    {
      title: i18n.t("nonFundHistory.refundTime"),
      key: "transactionTime",
      align: "center",
      minWidth: 200
    },
    {
      title: i18n.t("nonFundHistory.refundAmount"),
      key: "refundAmount",
      align: "center",
      minWidth: 140
    },
    {
      title: i18n.t("nonFundHistory.refundedAmount"),
      key: "refundedAmount",
      align: "center",
      minWidth: 140
    },
    {
      title: i18n.t("nonFundHistory.refundResultDesc"),
      key: "refundResultDesc",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.createName"),
      key: "createName",
      align: "center",
      minWidth: 100
    },
    {
      title: i18n.t("nonFundHistory.orderNo"),
      key: "orderNo",
      align: "center",
      minWidth: 160
    }
  ];

  public tableChangeRecord(val: number) {
    this.formInlineRecord.globalPageIndex = val;
    this.getTableListRecord();
  }
  public tableSizeChangeRecord(val: number) {
    this.formInlineRecord.globalPageSize = val;
    this.getTableListRecord();
  }

  private timeFnStartTimeRecord(val: objAny): void {
    if (val) {
      this.searchKeysRecord.startTime = val;
      this.timeRecord.startTime = this.searchKeysRecord.startTime;
    } else {
      this.searchKeysRecord.startTime = "";
      this.timeRecord.startTime = "";
    }
  }
  private timeFnEndTimeRecord(val: objAny): void {
    if (val) {
      this.searchKeysRecord.endTime = val;
      this.timeRecord.endTime = this.searchKeysRecord.endTime;
    } else {
      this.searchKeysRecord.endTime = "";
      this.timeRecord.endTime = "";
    }
  }

  async getTableListRecord() {
    if (!this.searchKeysRecord.startTime || !this.searchKeysRecord.endTime) {
      this.$Message.error(i18n.t("formText.timeNull") + "");
      return;
    }
    const firstTime = this.searchKeysRecord.startTime;
    const secondTime = this.searchKeysRecord.endTime;
    const startTime =
      firstTime.split(" ")[0].split("-")[0] +
      firstTime.split(" ")[0].split("-")[1] +
      firstTime.split(" ")[0].split("-")[2];
    const endTime =
      secondTime.split(" ")[0].split("-")[0] +
      secondTime.split(" ")[0].split("-")[1] +
      secondTime.split(" ")[0].split("-")[2];
    if (startTime > endTime) {
      this.$Message.error(i18n.t("formText.timeMax") + "");
      return;
    }

    this.formInlineRecord.dateStr =
      this.searchKeysRecord.startTime + "~" + this.searchKeysRecord.endTime;

    // const params: objAny = {
    //   // startTime: this.searchKeys.startTime,
    //   // endTime: this.searchKeys.endTime,
    //   //   globalSearch: this.searchKeysRecord.globalSearch,

    //   dateStr: dateStr,
    //   globalPageIndex: this.formInlineRecord.globalPageIndex,
    //   globalPageSize: this.formInlineRecord.globalPageSize,
    //   globalOrder: this.formInlineRecord.globalOrder,
    //   cardPkId: this.formInlineRecord.cardPkId
    // };
    const ret = await getCardRecord(this.formInlineRecord);
    if (ret.status === this.$config.apiStatus) {
      if (ret.data) {
        this.tableListRecord = ret.data;
        this.totalRecord = ret.total;
      } else {
        this.tableListRecord = [];
        this.totalRecord = ret.total;
      }
    }
  }

  public tableChangeRecharge(val: number) {
    this.formInlineRecharge.globalPageIndex = val;
    this.getTableListRecharge();
  }
  public tableSizeChangeRecharge(val: number) {
    this.formInlineRecharge.globalPageSize = val;
    this.getTableListRecharge();
  }
  private timeFnStartTimeRecharge(val: objAny): void {
    if (val) {
      this.searchKeysRecharge.startTime = val;
      this.timeRecharge.startTime = this.searchKeysRecharge.startTime;
    } else {
      this.searchKeysRecharge.startTime = "";
      this.timeRecharge.startTime = "";
    }
  }
  private timeFnEndTimeRecharge(val: objAny): void {
    if (val) {
      this.searchKeysRecharge.endTime = val;
      this.timeRecharge.endTime = this.searchKeysRecharge.endTime;
    } else {
      this.searchKeysRecharge.endTime = "";
      this.timeRecharge.endTime = "";
    }
  }

  async getTableListRecharge() {
    if (
      !this.searchKeysRecharge.startTime ||
      !this.searchKeysRecharge.endTime
    ) {
      this.$Message.error(i18n.t("formText.timeNull") + "");
      return;
    }
    const firstTime = this.searchKeysRecharge.startTime;
    const secondTime = this.searchKeysRecharge.endTime;
    const startTime =
      firstTime.split(" ")[0].split("-")[0] +
      firstTime.split(" ")[0].split("-")[1] +
      firstTime.split(" ")[0].split("-")[2];
    const endTime =
      secondTime.split(" ")[0].split("-")[0] +
      secondTime.split(" ")[0].split("-")[1] +
      secondTime.split(" ")[0].split("-")[2];

    if (startTime > endTime) {
      this.$Message.error(i18n.t("formText.timeMax") + "");
      return;
    }
    this.formInlineRecharge.dateStr =
      this.searchKeysRecharge.startTime + "~" + this.searchKeysRecharge.endTime;
    const ret = await getCardRecharge(this.formInlineRecharge);
    if (ret.status === this.$config.apiStatus) {
      //   if (ret.data) {
      this.tableListRecharge = ret.data || [];
      this.totalRecharge = ret.total;
      //   } else {
      //     this.tableListRecharge = [];
      //   }
    }
  }

  public tableChangeRefund(val: number) {
    this.formInlineRefund.globalPageIndex = val;
    this.getTableListRefund();
  }
  public tableSizeChangeRefund(val: number) {
    this.formInlineRefund.globalPageSize = val;
    this.getTableListRefund();
  }

  private timeFnStartTimeRefund(val: objAny): void {
    if (val) {
      this.searchKeysRefund.startTime = val;
      this.timeRefund.startTime = this.searchKeysRefund.startTime;
    } else {
      this.searchKeysRefund.startTime = "";
      this.timeRefund.startTime = "";
    }
  }
  private timeFnEndTimeRefund(val: objAny): void {
    if (val) {
      this.searchKeysRefund.endTime = val;
      this.timeRefund.endTime = this.searchKeysRefund.endTime;
    } else {
      this.searchKeysRefund.endTime = "";
      this.timeRefund.endTime = "";
    }
  }
  async getTableListRefund() {
    if (!this.searchKeysRefund.startTime || !this.searchKeysRefund.endTime) {
      this.$Message.error(i18n.t("formText.timeNull") + "");
      return;
    }
    const firstTime = this.searchKeysRefund.startTime;
    const secondTime = this.searchKeysRefund.endTime;
    const startTime =
      firstTime.split(" ")[0].split("-")[0] +
      firstTime.split(" ")[0].split("-")[1] +
      firstTime.split(" ")[0].split("-")[2];
    const endTime =
      secondTime.split(" ")[0].split("-")[0] +
      secondTime.split(" ")[0].split("-")[1] +
      secondTime.split(" ")[0].split("-")[2];

    if (startTime > endTime) {
      this.$Message.error(i18n.t("formText.timeMax") + "");
      return;
    }
    this.formInlineRefund.dateStr =
      this.searchKeysRefund.startTime + "~" + this.searchKeysRefund.endTime;
    const ret = await getCardRefund(this.formInlineRefund);
    if (ret.status === this.$config.apiStatus) {
      //   if (ret.data) {
      this.tableListRefund = ret.data;
      this.totalRefund = ret.total;
      //   } else {
      //     this.tableListRefund = [];
      //   }
    }
  }

  public queryClickRecord() {
    this.formInlineRecord.globalPageIndex = 1;
    this.getTableListRecord();
  }

  public queryClickRecharge() {
    this.formInlineRecharge.globalPageIndex = 1;
    this.getTableListRecharge();
  }

  public queryClickRefund() {
    this.formInlineRefund.globalPageIndex = 1;
    this.getTableListRefund();
  }

  mounted() {
    const item = this["$common"].get("non-real-name-card-management-item");
    this.formInlineRecord.cardPkId = item.cardPkId;
    this.formInlineRecharge.cardPkId = item.cardPkId;
    this.formInlineRefund.cardPkId = item.cardPkId;

    const startTime = this.$common.thisTimes("yyyy-MM");
    const endTime = this.$common.thisTimes("yyyy-MM-dd");
    this.searchKeysRecord.startTime = startTime + "-01";
    this.searchKeysRecord.endTime = endTime;
    this.timeRecord.startTime = this.searchKeysRecord.startTime;
    this.timeRecord.endTime = this.searchKeysRecord.endTime;

    this.searchKeysRecharge.startTime = startTime + "-01";
    this.searchKeysRecharge.endTime = endTime;
    this.timeRecharge.startTime = this.searchKeysRecharge.startTime;
    this.timeRecharge.endTime = this.searchKeysRecharge.endTime;

    this.searchKeysRefund.startTime = startTime + "-01";
    this.searchKeysRefund.endTime = endTime;
    this.timeRefund.startTime = this.searchKeysRefund.startTime;
    this.timeRefund.endTime = this.searchKeysRefund.endTime;

    this.getTableListRecord();
    this.getTableListRecharge();
    // this.getTableListRefund();
  }
}
